import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: radial-gradient(circle at 12% 12%, rgba(224, 231, 255, 0.75), transparent 30rem), #f8fafc;
}

.home-link {
  display: flex;
  min-width: 0;
  gap: 0.875rem;
  border: 1px solid rgb(226, 232, 240);
  border-radius: 0.875rem;
  padding: 1rem;
  background: white;
  transition: border-color 150ms ease, background-color 150ms ease, transform 150ms ease;
}

.home-link:hover {
  border-color: rgb(165, 180, 252);
  background: rgb(238, 242, 255);
  transform: translateY(-1px);
}

.home-link:focus-visible {
  outline: 2px solid rgb(79, 70, 229);
  outline-offset: 2px;
}

.home-link-number {
  display: inline-flex;
  height: 2rem;
  width: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.625rem;
  background: rgb(238, 242, 255);
  color: rgb(79, 70, 229);
  font-size: 0.6875rem;
  font-weight: 800;
}`],
})
export class PageHomeComponent implements OnInit {
    public async ngOnInit() {
    }
}

export default PageHomeComponent;